import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import validationHelper from "./validationHelper";

const { isNegativeNumber } = validationHelper;

const snakeCaseToCamelCase = (string) => {
  const regex = /(\_\w)/g; //eslint-disable-line
  const camelCaseString = string.replace(regex, (matches) =>
    matches[1].toUpperCase()
  );

  return camelCaseString;
};

const camelize = (string = "") => {
  const updatedString = string.replace(/[-_\s.]+(.)?/g, (_, c) =>
    c ? c.toUpperCase() : ""
  );
  return updatedString.substr(0, 1).toLowerCase() + updatedString.substr(1);
};

function formatNumberWithSymbol(d, settings, currencySymbol, currencySettings) {
  const applyDecimals =
    settings && settings.decimals >= 0 ? settings.decimals : 2;
  const type = (settings && settings.units) || "";
  const isNegative = isNegativeNumber(d);
  const numberSettings = getNumberRepresentation(currencySettings);
  let num = d;
  let formattedNumber = d;
  if (isNegative) {
    num = Math.abs(d);
  }
  let formatted = false;
  const symbol = !isEmpty(currencySymbol) ? currencySymbol : "";
  switch (type) {
    case "currency":
      for (let i = 0; i < numberSettings.length; i += 1) {
        if (num >= numberSettings[i].value) {
          const value = num / numberSettings[i].value;
          formattedNumber = isNegative
            ? truncateNumber(value, 2) * -1
            : truncateNumber(value, 2);
          formattedNumber = new Intl.NumberFormat().format(formattedNumber);
          formattedNumber = `${symbol}${formattedNumber}${numberSettings[i].symbol}`;
          formatted = true;
          break;
        }
      }
      if (!formatted) {
        formattedNumber = isNegative
          ? truncateNumber(num, applyDecimals) * -1
          : truncateNumber(num, applyDecimals);
        formattedNumber = new Intl.NumberFormat().format(formattedNumber);
        formattedNumber = `${symbol}${formattedNumber}`;
      }
      break;
    default:
    case "number":
      for (let i = 0; i < numberSettings.length; i += 1) {
        if (num >= numberSettings[i].value) {
          const value = num / numberSettings[i].value;
          formattedNumber = isNegative
            ? truncateNumber(value, 2) * -1
            : truncateNumber(value, 2);
          formattedNumber = new Intl.NumberFormat().format(formattedNumber);
          formattedNumber = `${formattedNumber}${numberSettings[i].symbol}`;
          formatted = true;
          break;
        }
      }
      if (!formatted) {
        formattedNumber = isNegative
          ? truncateNumber(num, applyDecimals) * -1
          : truncateNumber(num, applyDecimals);
        formattedNumber = new Intl.NumberFormat().format(formattedNumber);
      }
      break;
    case "percent":
      formattedNumber = new Intl.NumberFormat([], {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: applyDecimals,
      }).format(formattedNumber / 100);
      break;
  }
  return formattedNumber;
}

function getNumberRepresentation(currencySettings) {
  const numberScaleType =
    currencySettings && currencySettings.label ? currencySettings.label : "";
  if (numberScaleType && numberScaleType.toUpperCase() === "INR") {
    return numberScaleINR;
  }
  return numberScale;
}

const numberScale = [
  { value: 1e12, symbol: "T" },
  { value: 1e9, symbol: "B" },
  { value: 1e6, symbol: "M" },
  { value: 1e3, symbol: "K" },
];

const numberScaleINR = [
  { value: 1e7, symbol: "Cr" },
  { value: 1e5, symbol: "L" },
  { value: 1e3, symbol: "K" },
];

function truncateNumber(num, places) {
  const numPower = 10 ** places;
  return Math.trunc(num * numPower) / numPower;
}

export const getUserLocale = (currentOrgDetails) => {
  const { basic_details = {} } = currentOrgDetails;
  const { base_country_code = "US", base_language = "en" } = basic_details;
  return `${base_language}-${base_country_code}`;
};

const hasDecimal = (number) => number.toString().includes('.');

const localeBasedNumberFormatting = (
  value = 0,
  currentOrgDetails = {},
  minimumFractionDigits,
) => {
  const userLocale = getUserLocale(currentOrgDetails);
  // If the required decimal places are not specified
  if (isNil(minimumFractionDigits)) {
    minimumFractionDigits = hasDecimal(value) ? 2 : 0;
  }
  const formattedValue = new Intl.NumberFormat(userLocale, {
    minimumFractionDigits
  }).format(value);
  return formattedValue;
};

export default {
  truncateNumber,
  numberScaleINR,
  numberScale,
  getNumberRepresentation,
  formatNumberWithSymbol,
  camelize,
  snakeCaseToCamelCase,
  getUserLocale,
  localeBasedNumberFormatting,
};
